import { render, staticRenderFns } from "./NsenControl.vue?vue&type=template&id=c2ede080&scoped=true&"
import script from "./NsenControl.vue?vue&type=script&lang=ts&"
export * from "./NsenControl.vue?vue&type=script&lang=ts&"
import style0 from "./NsenControl.vue?vue&type=style&index=0&id=c2ede080&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ede080",
  null
  
)

export default component.exports